(function ($) {

	// Care services page
	$(".categories-dropdown .service-category-list").change( function() {
		if( $(this).val() !== '' ) {
			var dropValue = $(this).val();

			$(".all-items .service-container").each( function() {
				if( $( this ).attr( "data-service" ) === dropValue ) {
					$( this ).attr("style", '');
				} 
				
				else {
					$( this ).attr("style", 'display: none;');
				}
			});
		}
	});

	// Hero video
	if( $( "video.connect-bg source" ).length > 0 ) {
		$( "video.connect-bg source" ).each( function() {
			var sourceFile  = $( this ).attr( "data-src" );
			var video			  = this.parentElement;
			var playPromise = video.play();
			
			$( this ).attr( "src", sourceFile );

			video.load();				

			if( playPromise !== undefined ) {
				playPromise.then(_ => {
					video.play();
				} )

				.catch( error => {
					console.log( error );
				} );
			}
		} );
	}		
})(jQuery);